const getters = {
  normalTipDlg:(state, getters) => {
    return {msg: "加载中", gray: false, cover: true}
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js